import React from 'react';
import HeaderItem from '../HeaderItem';

const HelpComponent: React.FC = () => {
    return (
        <a href="/ORCA web user guide version 1.12.pdf" target="_blank">
            <HeaderItem title={'Help'} iconName={'question-circle'} path={''} />
        </a>
    );
};

export default HelpComponent;
